import Toggle from '@resources/js/ui/Toggle'

class Dropdown {
	#toggle
	#outSideClickListener

	constructor(triggerSelector, ...props) {
		this.#outSideClickListener = this.#handleOutsideClick.bind(this)

		document.body.addEventListener('click', this.#outSideClickListener)
		this.#toggle = new Toggle(triggerSelector, ...props)
	}

	#handleOutsideClick(e) {
		const trigger = this.#toggle.trigger
		const target = this.#toggle.target

		// Якщо клікнули на дропдаун або кнопку(тригер даного дропдауна) або дочірній елемент дропдауна чи кнопки
		if (
			trigger === e.target ||
			trigger.contains(e.target) ||
			target === e.target ||
			target.contains(e.target)
		)
			return

		this.hide()
	}

	show() {
		this.#toggle.show()
	}

	hide() {
		this.#toggle.hide()
	}

	destroy() {
		document.body.removeEventListener('click', this.#outSideClickListener)
		this.#toggle.destroy()
	}
}

export default Dropdown
